// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"640":"7b646771","647":"52f90152"}[chunkId] + ".chunk.css";
};